var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overflow-btn',{attrs:{"items":_vm.periods,"label":"Tryout"},on:{"change":_vm.selectPeriod},model:{value:(_vm.selectedIdx),callback:function ($$v) {_vm.selectedIdx=$$v},expression:"selectedIdx"}})}
var staticRenderFns = []

export { render, staticRenderFns }